<script>
import {defineComponent} from "vue";

import Dialog from "primevue/dialog";

export default defineComponent({
  components: {Dialog},
  emits: ['closeModal'],
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    closable: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  setup(_, { emit }) {
    const closeModal = () => {
      emit('closeModal')
    }
    return {
      closeModal,
    }
  }
});
</script>

<template>
  <Dialog
      :visible="visible"
      modal
      :close-on-escape="true"
      :closable="closable"
      :style="{ 'max-width': '500px', 'border-radius': '25px' }"
  >
    <template #header>
      <span class="font-bold">
        <slot name="header"></slot>
      </span>
    </template>
    <template #closeicon>
      <img src="@/assets/images/icons/Close.svg" @click="closeModal" />
    </template>

    <template #default>
      <span v-if="!closable">
        <slot name="default"></slot>
      </span>
      <slot v-else name="default"></slot>
    </template>

    <template #footer>
      <slot name="footer"></slot>
    </template>
  </Dialog>
</template>

<style lang="scss">
  .p-dialog-header-icon {
    box-shadow: unset !important;
    &:focus {
      box-shadow: unset !important;
    }
  }
</style>